import * as React from "react";

import $ = require('jquery');
import * as l10nReactMacros from 'diy/util/l10nReactMacros';
import globalEvents = require('diy/util/globalEvents');
import bsaEvents = require('diy/bsa-events/bsaEvents');

import {StepConfig} from "./components/Step";

const stepConfig: { [id: string]: StepConfig } = {
    'apps': {
        helpId: 'app_catalog_main',
        imageId: 'apps',
        onAction: () => {
            diy.editor.siteadmin.api.close();
            $('#cc-sa-item-appscatalog').trigger('click');
        },
    },
    'businessIdentity': {
        helpId: 'semanticdata_mydata',
        imageId: 'businessIdentity',
        onAction: () => {
            let openParams = [
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'personal-data'}
            ];
            diy.editor.deeplinking.requestPath(openParams);
        },
    },
    'elements': {
        helpId: 'moduleSelector',
        imageId: 'elements',
        vimeoUrlIds: {
            'de': '185603145'
        },
        onAction: () => {
            $('#cc-sa-item-elements').trigger('click');
        }
    },
    'emailAddress': {
        helpId: 'create_mailbox',
        imageId: 'emailAddress',
        onAction: () => {
            diy.editor.siteadmin.api.close();
            diy.util.redirector.redirectToLabel('choose_an_email_redirect_from_guidedSetup');
        },
        renderDoableMessage: () => {
            const macros = new Map() as l10nReactMacros.MacroSet;
            macros.set("link", (macro: string, index: number, inner: l10nReactMacros.MacroReplacement) => {
                return (
                    <a key="emailAddress" onClick={
                        () => diy.util.redirector.redirectToLabel('domain_connect_redirect-guidedsetup')
                    } href="#">{inner}</a>
                );
            });
            return (
                <div>
                    {l10nReactMacros.processStringMacros(
                        'onboardingGuide.step.emailAddress.notDoable', macros
                    )}
                </div>
            );
        },
    },
    'imagePool': {
        helpId: 'settings_images_cip',
        imageId: 'imagePool',
        vimeoUrlIds: {
            'de': '185601777'
        },
        onAction: () => {
            diy.editor.siteadmin.api.close();
            diy.editor.filemanager = new diy.editor.Filemanager({
                appName: 'filemanager',
                mode: 'management',
                sources: {"storage": true, "cms": true, "bigstock": true, "123rf": true},
                maxSelection: 1,
                alreadyExisting: 0,
                callback: (report: any) => {
                    //XXX: this comment to avoid empty block warning
                }
            });
        },
    },
    'learnTheInterface': {
        helpId: 'guidedSetup',
        imageId: 'learnTheInterface',
        onAction: () => {
            diy.editor.guidance.start();
        },
    },
    'navigation': {
        helpId: 'navigation',
        imageId: 'navigation',
        onAction: () => {
            diy.editor.siteadmin.api.close();
            diy.editor.navigation.api.openEditor();
        },
    },
    'publish': {
        helpId: 'first_publish',
        imageId: 'publish',
        onAction: () => {
            diy.editor.siteadmin.api.close();
            globalEvents.trigger('diy-maintenance-mode-show');
        },
    },
    'sections': {
        helpId: 'sections',
        imageId: 'sections',
        onAction: () => {
            $('#cc-sa-item-sections').trigger('click');
        },
    },
    'seoGetFound': {
        helpId: 'seo-use-guide',
        imageId: 'seoGetFound',
        onAction: () => {
            diy.editor.siteadmin.api.close();
            $('#cc-sa-item-get-found').trigger('click');
        },
    },
    'social': {
        imageId: 'social',
        showSocialButtons: true,
        onAction: () => {
            diy.editor.siteadmin.api.close();
            bsaEvents.trigger('SocialShareDone.BSA');
        },
    },
    'style': {
        helpId: 'style_overview',
        imageId: 'style',
        vimeoUrlIds: {
            'de': '185603155'
        },
        onAction: () => {
            $('#cc-sa-item-style').trigger('click');
        },
    },
    'vcard': {
        helpId: 'sa-staging',
        imageId: 'vcard',
        onAction: () => {
            diy.editor.siteadmin.api.close();
            globalEvents.trigger('diy-maintenance-mode-edit');
        },
    },
};

export function getConfigForStep(id: string): StepConfig {
    if (stepConfig[id]) {
        return stepConfig[id];
    }
    throw new Error(`Invalid step identifier '${id}'.`);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/stepConfig.tsx
 **/